var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ErrorBoundary',[_c('router-view',{attrs:{"device-type":_vm.deviceType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }